import izitoast from 'izitoast';
import 'izitoast/dist/css/iziToast.css';

export default izitoast;
